import { Navigate, Route, useParams } from 'react-router-dom';

/**
 * Old URLs kept alive for bookmarks and links in past notification emails.
 * Review and remove by 2027-02-01: by then a full school term of emails will
 * have aged out. Check Vercel request logs for hits before deleting.
 */
export const LEGACY_REDIRECTS_REMOVE_BY = '2027-02-01';

// Redirects legacy student-profile URLs (previously under /staff/documents)
// to the module-neutral /staff/students/:id route.
const LegacyStudentProfileRedirect = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/staff/students/${id}`} replace />;
};

interface LegacyRedirect {
  from: string;
  /** Target path; omitted for the parameterised student-profile redirect. */
  to?: string;
  /** Whether the redirect replaces the history entry (kept as it was). */
  replace?: boolean;
  why: string;
}

export const legacyRedirects: LegacyRedirect[] = [
  { from: '/staff/documents/students', to: '/staff/students', replace: true, why: 'Student list moved to a module-neutral path' },
  { from: '/staff/documents/student-detail/:id', why: 'Profile used to live under /staff/documents' },
  { from: '/staff/student-detail/:id', why: 'Profile used to live under /staff/documents' },
  { from: '/staff/documents/settings', to: '/staff/settings', why: 'Settings unified' },
  { from: '/staff/documents/student-subjects/:id', to: '/staff/students', replace: true, why: 'Subject assignment retired (#379); classes come from SCR Central (#192)' },
  { from: '/staff/case-notes/settings', to: '/staff/settings', why: 'Settings unified' },
];

export const legacyRedirectRoutes = (
  <>
    {legacyRedirects.map((r) => (
      <Route
        key={r.from}
        path={r.from}
        element={r.to ? <Navigate to={r.to} replace={r.replace} /> : <LegacyStudentProfileRedirect />}
      />
    ))}
  </>
);
